import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import CSP_logo from "../assets/img/CSP_logo.png";
import AMI_T from "../assets/img/AMI_T.png";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cogoToast from "cogo-toast";
import { onLogin } from "../state/reducers/userSlice";
import { setfacilitiesList } from "../state/reducers/facilityListSlice";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { useOktaAuth } from "@okta/okta-react";
import helperService from "../services/helper";
import userService from "../services/users-service";
import OKTA_login from "../assets/img/okta_login.png";

const Home = ({ onLogin, history }) => {
  const { authState, oktaAuth } = useOktaAuth();
  useEffect(() => {
    if (authState?.isAuthenticated) {
      handleUser();
    }
  }, [authState?.isAuthenticated]);
  const login = async () => {
    await oktaAuth.signInWithRedirect();
  };
  const handleUser = async () => {
    try {
      await helperService.setHeaders(
        "Authorization",
        `Bearer ${authState.accessToken.accessToken}`
      );
      const user = await userService.getUserProfile();
      user.token = authState.accessToken.accessToken;
      await onLogin({ user });
      await history.push("/dashboard");
    } catch (e) {
      const { hide } = cogoToast.error(e.message, {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
 
  return (
    <div className="p-2 min-h-screen bg-hero-pattern bg-cover bg-no-repeat bg-center">
      <header>
        <img
          alt=""
          className="w-7/12 md:w-64 mx-auto mt-7 md:ml-16 md:mt-8"
          src={CSP_logo}
        />
      </header>

      {!authState?.isAuthenticated && (
        <div className="flex w-full h-full">
          <div className="w-1/3 h-full">
            <img alt="" className="flex mt-7" src={AMI_T} />
          </div>
          <div
            className="w-5/6 md:w-1/3 mr-8 bg-white rounded mt-14   pt-10 pb-10 h-fit shadow-loginshadow
      border-borderclr"
          >
            <p className="text-grey_color text-center mb-6 font-bold">LOGIN</p>
            {!authState?.isAuthenticated && (
              <img
                alt=""
                onClick={login}
                className="w-7/12 md:w-64 mx-auto mt-7 md:mt-8"
                src={OKTA_login}
              />
            )}
          </div>
        </div>
      )}

      {authState?.isAuthenticated && (
        <div className="inline-block customtop absolute z-50 show">
          <Loader type="Oval" color="#00B2A9" height={100} width={100} />
        </div>
      )}
    </div>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({ onLogin, setfacilitiesList }, dispatch);
    }
  )(Home)
);
